export enum DeviceQuality {
    SUPER_LOW = 0, LOW = 1, MEDIUM = 2, HIGH = 3
}